module.exports = __webpack_public_path__ + "img/5.91de0c0a.png";